import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchUsers } from 'redux/users/actions';
import { getUsers } from 'redux/users/selectors';

import customer from 'components/core/steps/selectAccount/customerInfo';
import Accounts from 'components/common/accounts/Accounts';
import { StyledSources } from './Sources.styles';

export class Sources extends Component {
  constructor(props) {
    super(props);

    const data = customer;
    this.state = {
      info: data.info,
    };
  }

  componentDidMount() {
    this.props.fetchUsersData();
  }

  render() {
    const { info } = this.state;
    const { user, users } = this.props;

    return (
      <StyledSources>
        <Accounts
          info={info}
          user={user}
          users={users}
        />
      </StyledSources>
    );
  }
}

const mapStateToProps = state => {
  const { account } = state.auth;
  const users = getUsers(state);

  return {
    user: account,
    users,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUsersData: () => dispatch(fetchUsers()),
  };
};

Sources.propTypes = {
  user: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sources);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Sources/Sources.jsx